export default {
  GET_REMAIN_BUDGET_LIST: "GET_REMAIN_BUDGET_LIST",
  GET_AVG_USAGE: "GET_AVG_USAGE",
  PAYMENT_HISTORY: "PAYMENT_HISTORY",
};
